module.exports = __webpack_public_path__ + "img/kopiarka-bg.8f24941c.png";